import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { EnquiryTopBanner } from "../components/EnquiryTopBanner";
import { enquiryOperationsList } from "../constants/enquiry.constants";
import { Button } from "@mui/material";
import { useState } from "react";
import dayjs from "configs/dayjs.config";

import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";
import { SearchUsers } from "components/SearchSelect/SearchUsers";
import { useEnquiryContext } from "../context";
import { useGlobalContext } from "context/GlobalContext";
import { addTaskForDocsApi } from "API/apis/docTasks/dockTask";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { taskDocId } from "constants/documentCode";
import { DatePickerWrapper } from "components/DateTimePicker/DatePicker";

const initialUserDetail = {
  name: "",
  dept: "",
  subDept: "",
  userId: "",
};

const initialState = {
  docType: taskDocId.enquiry,
  docId: 0,
  taskDetails: "",
  deadline: new Date(),
  taskTo: { name: "", dept: "", subDept: "", userId: "" },
  companyId: 0,
  docDetails: "",
};

export const EnquiryTask = () => {
  const [formData, setFormData] = useState(initialState);
  const [selectedTaskByUser, setSelectedTaskByUser] =
    useState(initialUserDetail);
  const [selectedTaskToUser, setSelectedTaskToUser] =
    useState(initialUserDetail);
  const { setIsLoading, setSuccess, setError } = useGlobalContext();
  const { previewEnquiry, setCurrentOperationPage } = useEnquiryContext();

  const handleDeliveryDateChange = (newValue) => {
    if (newValue) {
      setFormData({
        ...formData,
        deadline: newValue.toDate(),
      });
    }
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      docType: taskDocId.enquiry,
      docId: previewEnquiry.id,
      docDetails: previewEnquiry.clientName,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddTaskUserSubmit = async (e) => {
    e.preventDefault();
    try {
      if (dayjs().subtract(1, "day") > formData.deadline) {
        throw new Error("Older dates are not allowed");
      }
      setIsLoading(true);
      const { data, status } = await addTaskForDocsApi({
        ...formData,
        taskTo: selectedTaskToUser?.userId || "",
        taskBy: selectedTaskByUser?.userId || "",
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setFormData(initialState);
      setSuccess(data?.message);
      setIsLoading(false);
      setCurrentOperationPage(enquiryOperationsList.listEnquiry);
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    }
  };
  return (
    <>
      <PageTitle pageName={pageName.enquiry.task} />
      <EnquiryTopBanner
        buttonType="back"
        enquiryOperationsParam={enquiryOperationsList.listEnquiry}
      />
      <form onSubmit={handleAddTaskUserSubmit}>
        <TextFieldWrapper
          multiline
          id="taskDetails"
          name="taskDetails"
          label="Task Detail"
          variant="outlined"
          value={formData.taskDetails}
          fullWidth
          required
          onChange={handleChange}
        />
        <TextFieldWrapper
          multiline
          id="taskDescription"
          name="taskDescription"
          label="Task Description"
          variant="outlined"
          value={formData.taskDescription}
          rows={5}
          fullWidth
          required
          onChange={handleChange}
        />
        <FormControlWrapper fullWidth>
          <SearchUsers
            label="Assign By"
            handleUserSelection={setSelectedTaskByUser}
            selectedUser={selectedTaskByUser}
          />
        </FormControlWrapper>
        <FormControlWrapper fullWidth>
          <SearchUsers
            label="Assign To"
            handleUserSelection={setSelectedTaskToUser}
            selectedUser={selectedTaskToUser}
          />
        </FormControlWrapper>
        <TextFieldWrapper
          id="alertBeforeDays"
          name="alertBeforeDays"
          label="Alert Before Days"
          variant="outlined"
          value={formData.alertBeforeDays}
          fullWidth
          inputProps={{ min: 1 }}
          required
          onChange={handleChange}
        />
        <FormControlWrapper fullWidth>
          <DatePickerWrapper
            label="Delivery Date"
            value={dayjs(formData.deadline)}
            onChange={(newValue) => handleDeliveryDateChange(dayjs(newValue))}
          />
        </FormControlWrapper>
        <Button variant="contained" type="submit" fullWidth>
          Submit
        </Button>
      </form>
    </>
  );
};
